import React, { useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import useFetchData from "../../hooks/useFetchData";
import { Button } from "@progress/kendo-react-buttons";
import { filterClearIcon } from "@progress/kendo-svg-icons";

const DropDownFilterCell = ({
  url,
  data,
  textField = "text",
  dataItemKey = "value",
  onChange,
}) => {
  const [selectedValue, setSelectedValue] = useState(null);

  const { data: fetchedData, loading } = useFetchData(url);

  const dropdownData = data || fetchedData;

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    onChange({
      value: event.target.value[dataItemKey].toLowerCase(),
      operator: "eq",
      syntheticEvent: event.syntheticEvent,
    });
  };

  const onClearButtonClick = (event) => {
    event.preventDefault();
    setSelectedValue(null);
    onChange({
      value: "",
      operator: "",
      syntheticEvent: event,
    });
  };
  return (
    <div className="k-filtercell k-filterable">
      <DropDownList
        data={dropdownData}
        onChange={handleChange}
        value={selectedValue}
        textField={textField}
        dataItemKey={dataItemKey}
        loading={loading}
      />
      <Button
        title="Clear"
        disabled={!selectedValue}
        onClick={onClearButtonClick}
        svgIcon={filterClearIcon}
      />
    </div>
  );
};

export default DropDownFilterCell;
